<template lang="pug">
  div.u-mtm(v-if='!isDigitalContent')
    ul.c-list-note.u-mtm.u-mb0.u-pl0(style="list-style: none;")
      li Prices for products shipping from our Japan warehouse may be updated without notice to reflect fluctuations in the JPY to USD exchange rate. Items shipping from our US warehouse will not be affected.
</template>

<script>
export default {
  computed: {
    isDigitalContent() {
      const selectedSku = this.$store.getters['product/skus/selectedSku'];
      return (selectedSku != null ? selectedSku.is_digital_content : undefined);
    }
  }
};
</script>
